import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Button,
  TextField,
  Table,
  TableBody,
  AppBar,
  Toolbar,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  Modal,
  DialogActions,
  TableCell,
  TableContainer,
  TableHead,
  styled,
  Box,
  TableRow,
  Paper,
  InputAdornment,
  TablePagination,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import LoadingBar from "react-top-loading-bar";
import SearchIcon from "@mui/icons-material/Search";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Tooltip from "@mui/material/Tooltip";
import base64 from "base64-js";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


const StyledButton = styled(Button)(({ theme }) => ({
  borderRadius: 20,
  padding: "8px 24px",
  textTransform: "none",
  fontWeight: 600,
  transition: "all 0.3s ease",
  "&:hover": {
    transform: "translateY(-2px)",
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
  },
}));

const MainCategory = () => {
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const navigate = useNavigate();
  const { encodedFormId } = useParams();
  console.log("encodedFormId:", encodedFormId);
  const [showUserGuide, setShowUserGuide] = useState(false);
  const [categories, setCategories] = useState([]);
  const [categoryToDelete, setCategoryToDelete] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [loadingBarProgress, setLoadingBarProgress] = useState(0);
  const [canEdit, setCanEdit] = useState(false);
  const [canDelete, setCanDelete] = useState(false);
  const [authorization, setAuthorization] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // Decode the encodedFormId
  const decodeFormId = (encodedFormId) => {
    const bytes = base64.toByteArray(encodedFormId);
    return new TextDecoder().decode(bytes);
  };
  const formId = decodeFormId(encodedFormId);

  const fetchCategories = async () => {
    try {
      setLoadingBarProgress(30);
      const apiUrl = process.env.REACT_APP_BASE_URL;
      console.log(
        "Fetching from:",
        `${apiUrl}/inventory/Categories/GetMainCategory`
      );
      const response = await fetch(
        `${apiUrl}/inventory/Categories/GetMainCategory`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: sessionStorage.getItem("token"),
          },
          body: JSON.stringify({}),
        }
      );

      if (response.ok) {
        const responseData = await response.json();
        console.log("Categories fetched:", responseData);
        setCategories(responseData || []);
      } else {
        console.error("Failed to fetch categories:", response.status);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      setLoadingBarProgress(100);
      setIsLoading(false);
    }
  };

  const Authorizer = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      setLoadingBarProgress(30);
      const token = sessionStorage.getItem("token");
      console.log("Sending decoded formId:", formId);

      const response = await fetch(`${apiUrl}/CPanel/Module_Authorizer`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          formId,
        }),
      });

      if (response.ok) {
        const responseData = await response.json();
        setAuthorization(responseData);
        const authorizationData = responseData[0];
        setCanDelete(authorizationData.uDelete === 1);
        setCanEdit(authorizationData.uModify === 1);
        setLoadingBarProgress(100);
      } else {
        console.error("Authorization failed:", response.status);
        // alert("Invalid authorization response");
        setSnackbarMessage('Invalid authorization response');
        setOpenSnackbar(true);
        setSnackbarSeverity("error")
        setLoadingBarProgress(0);
      }
    } catch (error) {
      console.error("API request error:", error);
      // alert("An error occurred. Please try again later.");
      setSnackbarMessage('An error occurred. Please try again later.');
      setOpenSnackbar(true);
      setSnackbarSeverity("error")
      setLoadingBarProgress(0);
    }
  };

  const handleClose = () => {
    setShowModal(false);
  }
  const handleAddCategory = () => {
    navigate("/itemcategorymaster/add", { state: { encodedFormId } });
  };

  const handleDeleteCategory = async (mainCategoryId) => {
    if (!canDelete) {
      // alert("You don’t have permission to delete categories.");
      setSnackbarMessage('You don’t have permission to delete categories.');
      setOpenSnackbar(true);
      setSnackbarSeverity("error")
      return;
    }



    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const response = await fetch(
        `${apiUrl}/inventory/Categories/Id?Id=${mainCategoryId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: sessionStorage.getItem("token"),
          },
        }
      );

      if (response.ok) {
        setCategories(
          categories.filter((cat) => cat.mainCategoryId !== mainCategoryId)
        );
        setShowModal(false);
        setSnackbarMessage('Category deleted successfully!');
        setOpenSnackbar(true);
        setSnackbarSeverity("success")
      } else {
        // alert("Failed to delete category");
        setSnackbarMessage('Failed to delete category');
        setOpenSnackbar(true);
        setSnackbarSeverity("error")
      }
    } catch (error) {
      console.error("Error deleting category:", error);
      // alert("An error occurred while deleting the category");
      setSnackbarMessage('An error occurred while deleting the category');
        setOpenSnackbar(true);
        setSnackbarSeverity("error")
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    console.log("Component mounted, fetching data...");
    fetchCategories();
    Authorizer();
  }, []);

  const filteredCategories = categories.filter((category) =>
    category.mainCategoryName?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const paginatedCategories = filteredCategories.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <div className="container">
      <LoadingBar
        progress={loadingBarProgress}
        color="rgb(152, 106, 182)"
        height={5}
      />
      <AppBar position="static" style={{ backgroundColor: "#0B1F3D" }}>
        <Toolbar>
          <Typography variant="h4" component="div" style={{ fontWeight: 'bold' }}>
            Category Management  <InfoIcon onClick={() => setShowUserGuide(true)} style={{ "opacity": "0.6" }} />
          </Typography>

          <Dialog
            open={showUserGuide}
            onClose={() => setShowUserGuide(false)}
            maxWidth="sm"
            fullWidth
            sx={{
              "& .MuiDialog-paper": {
                borderRadius: "12px",
                boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
                backgroundColor: "#f9fafb",
              },
            }}
          >
            <DialogTitle
              sx={{
                background: "linear-gradient(90deg, #1898c2 0%, #beab6c 100%)",
                color: "white",
                fontWeight: "bold",
                textAlign: "center",
                borderRadius: "12px 12px 0 0",
                py: 2,
              }}
            >
              Fee Deposit User Guide
            </DialogTitle>
            <DialogContent sx={{ padding: "24px" }}>
              <Typography
                variant="h6"
                sx={{
                  color: "#1898c2",
                  fontWeight: "600",
                  mb: 2,
                  mt: 1,
                  textAlign: "center",
                }}
              >
                Quick Steps to Manage Categories
              </Typography>
              <Box
                component="ul"
                sx={{
                  listStyleType: "none",
                  padding: 0,
                  "& li": {
                    display: "flex",
                    alignItems: "flex-start",
                    mb: 1.5,
                    fontSize: "0.9rem",
                    color: "#333",
                  },
                  "& li::before": {
                    content: '"\\2022"', // Bullet point
                    color: "#1898c2",
                    fontWeight: "bold",
                    display: "inline-block",
                    width: "1.5em",
                    mr: 1,
                    fontSize: "1.2rem",
                  },
                  "& strong": {
                    margin: "0 0.2em", // Add spacing around strong tags
                  },
                }}
              >
                <li><strong>Search</strong> categories by name</li>
                <li><strong>Add</strong> new categories with the "Add Category" button</li>
                <li><strong>Edit</strong> existing categories (if authorized)</li>
                <li><strong>Delete</strong> categories (with confirmation)</li>
                <li>View <strong>descriptions</strong> for each category</li>
                <li>Use <strong>pagination</strong> to navigate large lists</li>
                <li>Check <strong>permission indicators</strong> for restricted actions</li>

              </Box>
            </DialogContent>
            <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
              <StyledButton
                onClick={() => setShowUserGuide(false)}
                color="primary"
                variant="contained"
                sx={{
                  backgroundColor: "#1898c2",
                  "&:hover": { backgroundColor: "#156f9a" },
                  borderRadius: "8px",
                  px: 4,
                }}
              >
                Close
              </StyledButton>
            </DialogActions>
          </Dialog>
        </Toolbar>
      </AppBar>

      <Paper elevation={3} style={{ padding: 16, marginTop: 6 }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 16,
          }}
        >
          <TextField
            variant="outlined"
            placeholder="Search categories..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            sx={{ width: 300, backgroundColor: "#f9f9f9" }}
          />
          <Button
            variant="contained"
            color="primary"
            onClick={handleAddCategory}
          // style={{ backgroundColor: "#0B1F3D" }}
          >
            Add Category
          </Button>
        </div>

        {isLoading ? (
          <Typography>Loading categories...</Typography>
        ) : (
          <>
            <TableContainer component={Paper} style={{ marginTop: 16 }}>
              <Table stickyHeader sx={{
                minWidth: 650,
                border: '1px solid #ccc',
                '& .MuiTableCell-root': {
                  borderRight: '1px solid #ccc',
                  fontSize: '1rem',
                },
                '& .MuiTableHead-root .MuiTableCell-root': {
                  fontWeight: 'bold',
                  backgroundColor: '#f5f5f5',
                },
              }}>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc', fontWeight: 'bold', fontSize: '1.1rem', width: "30%" }}>
                      Category Name
                    </TableCell>
                    <TableCell sx={{ borderRight: '1px solid #ccc', borderBottom: '1px solid #ccc', fontWeight: 'bold', fontSize: '1.1rem', width: "40%" }}>
                      Description
                    </TableCell>
                    <TableCell sx={{ borderBottom: '1px solid #ccc', borderRight: '1px solid #ccc', textAlign: 'center', fontWeight: 'bold', fontSize: '1.1rem', width: "30%", minWidth: 200 }}>
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paginatedCategories.length > 0 ? (
                    paginatedCategories.map((category) => (
                      <TableRow key={category.mainCategoryId} sx={{ borderTop: '1px solid #ccc' }}>
                        <TableCell sx={{ borderRight: '1px solid #ccc', fontSize: '1.1rem', whiteSpace: "normal", wordWrap: "break-word" }}>
                          {category.mainCategoryName || "N/A"}
                        </TableCell>
                        <TableCell sx={{ borderRight: '1px solid #ccc', fontSize: '1.1rem', whiteSpace: "normal", wordWrap: "break-word" }}>
                          {category.description || "N/A"}
                        </TableCell>
                        <TableCell sx={{ textAlign: 'center', borderRight: '1px solid #ccc', fontSize: '1.1rem' }}>
                          <Tooltip title={canEdit ? "" : "Not authorized to edit"} arrow>
                            <span>
                              <Button
                                variant="contained"
                                color="warning"
                                onClick={() => navigate(`/edit-main-category/${category.mainCategoryId}`)}
                                disabled={!canEdit}
                                sx={{ marginRight: 1, minWidth: 80 }}
                                startIcon={<EditIcon />}
                              >
                                Edit
                              </Button>
                            </span>
                          </Tooltip>
                          <Tooltip title={canDelete ? "" : "Not authorized to delete"} arrow>
                            <span>
                              <Button
                                variant="contained"
                                color="error"

                                onClick={() => { setCategoryToDelete(category.mainCategoryId); setShowModal(true) }}
                                disabled={!canDelete}
                                sx={{ marginRight: 1, minWidth: 80 }}
                                startIcon={<DeleteIcon />}
                              >
                                Delete
                              </Button>
                            </span>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={3} sx={{ textAlign: 'center' }}>No categories available</TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={filteredCategories.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </>
        )}
      </Paper>

      <Modal open={showModal} onClose={handleClose} aria-labelledby="delete-modal-title" aria-describedby="delete-modal-description">
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          {/* Header */}
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="delete-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Delete Confirmation ⚠️
            </Typography>
          </Box>

          {/* Content */}
          <Box sx={{ padding: '20px' }}>
            <Typography id="delete-modal-description" sx={{ mb: 2 }}>
              Are you sure you want to delete this Category?
            </Typography>

            {/* Buttons */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button onClick={handleClose} variant="outlined" sx={{ mr: 1 }}>
                Cancel
              </Button>
              <Button
                variant="contained"
                color="error"
                onClick={() => handleDeleteCategory(categoryToDelete)}
              >
                Yes, Delete
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>


    </div>
  );
};

export default MainCategory;
